import { Focus, X, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

export interface FocusTagProps {
  children: ReactNode;
  onDismiss: () => void;
  /** Leading icon. Defaults to the Focus crosshair. */
  icon?: LucideIcon;
  className?: string;
}

export function FocusTag({ children, onDismiss, icon: Icon = Focus, className }: FocusTagProps) {
  return (
    <div
      className={cn(
        // `min-w-0` + a truncating label: in a row too narrow for it, the tag
        // gives up label text, never its icon or dismiss button.
        'flex h-[25px] min-w-0 items-center gap-1.5 rounded-[4px] bg-orange-100 px-2 text-dawn-black',
        className
      )}
    >
      <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-dawn-black" strokeWidth={2} />
      <span className="truncate text-[13px] leading-[1.3]">{children}</span>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
        className="flex shrink-0 items-center justify-center rounded hover:bg-orange-100"
      >
        <X className="h-3 w-3" strokeWidth={2} aria-hidden="true" />
      </button>
    </div>
  );
}

FocusTag.displayName = 'FocusTag';
